'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UIGrid = require('UIComponents/grid/UIGrid');

var _UIGrid2 = _interopRequireDefault(_UIGrid);

var _UIGridItem = require('UIComponents/grid/UIGridItem');

var _UIGridItem2 = _interopRequireDefault(_UIGridItem);

var _Config = require('../selectors/Config');

var _Steps = require('../selectors/Steps');

var _getStepOptions = require('../utils/getStepOptions');

var _getStepOptions2 = _interopRequireDefault(_getStepOptions);

var _isNewSignupUx = require('../utils/isNewSignupUx');

var _isNewSignupUx2 = _interopRequireDefault(_isNewSignupUx);

var _PageAsync = require('./loadable/PageAsync');

var _getCustomSidebarOption = require('./sidebar/custom/getCustomSidebarOption');

var _Sidebar = require('./sidebar/Sidebar');

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _StepHeader = require('./StepHeader');

var _StepHeader2 = _interopRequireDefault(_StepHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Page = exports.Page = function (_React$Component) {
  _inherits(Page, _React$Component);

  function Page() {
    _classCallCheck(this, Page);

    return _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).apply(this, arguments));
  }

  _createClass(Page, [{
    key: 'getClasses',
    value: function getClasses() {
      var currentStepKey = this.props.currentStepKey;

      var handlerOpts = (0, _getStepOptions2.default)(currentStepKey);

      return (0, _classNames2.default)('main', 'page-signup', {
        expanded: handlerOpts.get('expandedWidth'),
        'page-sidebar': (0, _isNewSignupUx2.default)() || (0, _Config.getIsEmbeddedContentFlow)(),
        'old-signup': !(0, _isNewSignupUx2.default)()
      });
    }
  }, {
    key: 'renderGrid',
    value: function renderGrid(children) {
      var _props = this.props,
          currentStepNumber = _props.currentStepNumber,
          totalSteps = _props.totalSteps;


      return (0, _getCustomSidebarOption.showSidebar)() || !(0, _isNewSignupUx.isNewSignupUXWithoutSidebar)() ? // Wordpress funnel uses new UX with no sidebar, so just uses the step header
      _react2.default.createElement(
        _UIGrid2.default,
        { className: 'user-registration-grid step-container step-container--wider p-top-0' },
        _react2.default.createElement(
          _UIGridItem2.default,
          {
            size: { sm: 12, md: 7, lg: 7, xl: 8 },
            style: { width: '100%' }
          },
          _react2.default.createElement(_StepHeader2.default, {
            totalSteps: totalSteps || 0,
            stepNumber: currentStepNumber,
            hasLoginLink: currentStepNumber === 0
          }),
          children
        ),
        _react2.default.createElement(
          _UIGridItem2.default,
          {
            className: 'step-column__sidebar',
            size: { sm: 12, md: 5, lg: 5, xl: 4 },
            style: {
              backgroundImage: 'linear-gradient(to top, #00a4bd, #00bda5)'
            }
          },
          _react2.default.createElement(_Sidebar2.default, null)
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_StepHeader2.default, {
          totalSteps: totalSteps || 0,
          stepNumber: currentStepNumber,
          hasLoginLink: currentStepNumber === 0
        }),
        children
      );
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var children = this.props.children;

      return (0, _isNewSignupUx2.default)() ? this.renderGrid(children) : children;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.getClasses() },
        _react2.default.createElement(_PageAsync.NotificationListAsync, null),
        this.renderContent()
      );
    }
  }]);

  return Page;
}(_react2.default.Component);

Page.propTypes = {
  children: _propTypes2.default.node.isRequired,
  currentStepKey: _propTypes2.default.string,
  currentStepNumber: _propTypes2.default.number,
  totalSteps: _propTypes2.default.number
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    currentStepKey: (0, _Steps.getCurrentStepKey)(state),
    currentStepNumber: (0, _Steps.getCurrentAppStepNumber)(state),
    totalSteps: (0, _Steps.getTotalSteps)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Page);